export default "__VITE_ASSET__DJnXb705__"